export enum RolesEnum {
  SUPER_ADMIN = 'Суперадминистратор',
  ADMIN = 'Администратор',
  ACCOUNT_MGR = 'Менеджер аккаунта'
}
